const useEnv = (env) => {
  const getEnv = (env) => {
    return process.env[`REACT_APP_${env}`] || '';
  };
  return env ? getEnv(env) : getEnv;
};

export default useEnv;
